var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay_inner"},[_c('div',{staticClass:"overlay_content"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.trans('common.loading')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }